var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-voting" }, [
    _vm.manualSelection.length <= 0 && _vm.$ceres.isShopBuilder
      ? _c("p", { staticStyle: { padding: "20px", "text-align": "center" } }, [
          _vm._v("Es wurden noch keine Artikel hinzugefügt")
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "items", class: { loading: this.loading } }, [
      _c(
        "div",
        { staticClass: "legend" },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _vm._m(4),
          _vm._v(" "),
          _vm._l(_vm.manualSelection, function(item, index) {
            return [
              _vm._l(item.data.variationProperties, function(property) {
                return index == 0 &&
                  _vm.varProps.map(Number).includes(property.property.id)
                  ? [
                      _c(
                        "div",
                        {
                          staticClass: "var-prop",
                          class: "vp-" + property.property.id,
                          style: "order:" + property.property.position
                        },
                        [
                          _c("div", { staticClass: "inner" }, [
                            _vm._v(_vm._s(property.property.names.name) + ":")
                          ])
                        ]
                      )
                    ]
                  : _vm._e()
              })
            ]
          }),
          _vm._v(" "),
          _vm._m(5),
          _vm._v(" "),
          _vm._m(6),
          _vm._v(" "),
          _vm._m(7)
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "overflow" },
        _vm._l(_vm.manualSelection, function(item, index) {
          return _c(
            "div",
            {
              staticClass: "i data-count",
              class: "i" + item.id,
              attrs: { "data-id": "i" + item.id }
            },
            [
              _c(
                "div",
                { staticClass: "img", staticStyle: { order: "-9999" } },
                [
                  _c("div", { staticClass: "inner" }, [
                    _c("img", {
                      attrs: {
                        src: item.data.images.all[0].urlMiddle,
                        alt: item.data.texts.name3
                      }
                    }),
                    _vm._v(" "),
                    item.id == parseFloat(_vm.winner)
                      ? _c("span", { staticClass: "winner" }, [
                          _vm._v(
                            "\n                            Preis Leistungs Sieger\n                        "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.id == parseFloat(_vm.recommendation)
                      ? _c("span", { staticClass: "winner rec" }, [
                          _vm._v(
                            "\n                            Kauf­empfehlung\n                        "
                          )
                        ])
                      : _vm._e()
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btnsx", staticStyle: { order: "-9999" } },
                [
                  _c(
                    "div",
                    { staticClass: "inner" },
                    [
                      _vm._l(item.data.variationProperties, function(property) {
                        return property.property.id == 57 &&
                          property.values.value == ""
                          ? [
                              _c(
                                "a",
                                {
                                  staticClass: "a",
                                  attrs: {
                                    href: "#cross" + item.id,
                                    "data-toggle": "modal"
                                  }
                                },
                                [_vm._v("Jetzt kaufen")]
                              )
                            ]
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _vm._l(item.data.variationProperties, function(property) {
                        return property.property.id == 57 &&
                          property.values.value.startsWith("http")
                          ? [
                              _c(
                                "a",
                                {
                                  staticClass: "amz a",
                                  attrs: {
                                    href: property.values.value,
                                    target: "_blank"
                                  }
                                },
                                [_vm._v("Bei Amazon kaufen")]
                              )
                            ]
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "title", staticStyle: { order: "-9999" } },
                [
                  _c("div", { staticClass: "inner" }, [
                    _vm._v(_vm._s(item.data.texts.name3))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "price", staticStyle: { order: "-9999" } },
                [
                  _c(
                    "div",
                    { staticClass: "inner" },
                    [
                      _vm._l(item.data.variationProperties, function(property) {
                        return property.property.id == 57 &&
                          property.values.value == ""
                          ? [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    item.data.prices.default.price.formatted
                                  ) +
                                  "\n                        "
                              )
                            ]
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _vm._l(item.data.variationProperties, function(property) {
                        return property.property.id == 57 &&
                          property.values.value == "x"
                          ? [
                              _vm._l(item.data.variationProperties, function(
                                property
                              ) {
                                return property.property.id == 48
                                  ? [
                                      _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            property.values.value
                                          )
                                        }
                                      })
                                    ]
                                  : _vm._e()
                              })
                            ]
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _vm._l(item.data.variationProperties, function(property) {
                        return property.property.id == 57 &&
                          property.values.value.startsWith("http")
                          ? [
                              _vm._l(item.data.variationProperties, function(
                                property
                              ) {
                                return property.property.id == 48
                                  ? [
                                      _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            property.values.value
                                          )
                                        }
                                      })
                                    ]
                                  : _vm._e()
                              })
                            ]
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "rating", staticStyle: { order: "-9999" } },
                [
                  _c(
                    "div",
                    { staticClass: "inner" },
                    [
                      _vm._l(item.data.variationProperties, function(property) {
                        return property.property.id == 57 &&
                          property.values.value == ""
                          ? [
                              item.data.item.feedbackCount
                                ? _c("span", { staticClass: "rate-txt" }, [
                                    _c("span", { staticClass: "rate-inner" }, [
                                      _c("span", { staticClass: "rate-blank" }),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass: "rate",
                                        style:
                                          "width:" +
                                          item.data.item.feedbackDecimal * 20 +
                                          "%"
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "txt" }, [
                                      _vm._v(
                                        "(" +
                                          _vm._s(item.data.item.feedbackCount) +
                                          ")"
                                      )
                                    ])
                                  ])
                                : _c("span", { staticClass: "rate-txt" }, [
                                    _vm._m(8, true),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "txt" }, [
                                      _vm._v("(0)")
                                    ])
                                  ])
                            ]
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _vm._l(item.data.variationProperties, function(property) {
                return _vm.varProps.map(Number).includes(property.property.id)
                  ? [
                      _c(
                        "div",
                        {
                          staticClass: "var-prop",
                          class: "vp-" + property.property.id,
                          style: "order:" + property.property.position
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "inner" },
                            [
                              property.values.value == "ja"
                                ? [_c("i", { staticClass: "icon-yes" })]
                                : property.values.value == "nein"
                                ? [_c("i", { staticClass: "icon-no" })]
                                : [
                                    _c("div", {
                                      domProps: {
                                        innerHTML: _vm._s(property.values.value)
                                      }
                                    })
                                  ]
                            ],
                            2
                          )
                        ]
                      )
                    ]
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm._l(item.data.variationProperties, function(property) {
                return property.property.id == 52
                  ? [
                      _c(
                        "div",
                        {
                          staticClass: "add-disa",
                          staticStyle: { order: "999" }
                        },
                        [
                          _c("div", {
                            staticClass: "inner",
                            domProps: {
                              innerHTML: _vm._s(property.values.value)
                            }
                          })
                        ]
                      )
                    ]
                  : _vm._e()
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "vote-container",
                  staticStyle: { order: "9999" }
                },
                [
                  _vm._l(_vm.votingjson, function(vote) {
                    return vote.itemId == item.data.variation.id
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "vote y",
                              attrs: {
                                "data-count": vote.count,
                                "data-percent": vote.percent
                              }
                            },
                            [
                              _c("div", { staticClass: "inner" }, [
                                _c("span", { staticClass: "bar-c" }, [
                                  _c("span", {
                                    staticClass: "bar",
                                    style:
                                      "width: calc(" + vote.percent + "% - 4px)"
                                  })
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(vote.percent) + "%")])
                              ])
                            ]
                          )
                        ]
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm._m(9, true)
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btns", staticStyle: { order: "10001" } },
                [
                  _c(
                    "div",
                    { staticClass: "inner" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "send-request b",
                          on: {
                            click: function($event) {
                              return _vm.sendRequest(
                                item.data.item.id,
                                item.id,
                                item.data.texts.name1
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                            Für dieses Gerät voten\n                        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(item.data.variationProperties, function(property) {
                        return property.property.id == 57 &&
                          property.values.value == ""
                          ? [
                              _c(
                                "a",
                                {
                                  staticClass: "a",
                                  attrs: {
                                    href: "#cross" + item.id,
                                    "data-toggle": "modal"
                                  }
                                },
                                [_vm._v("Jetzt kaufen")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "cross-modal",
                                  attrs: { id: "cross-modal-wrapper" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "modal fade",
                                      attrs: {
                                        id: "cross" + item.id,
                                        tabindex: "-1",
                                        role: "dialog"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "modal-dialog modal-lg"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "modal-content" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "modal-header" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "modal-title"
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.data.texts
                                                              .name3
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(
                                                        " Folgende Varianten stehen zur Auswahl:"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass: "close",
                                                      attrs: {
                                                        type: "button",
                                                        "data-dismiss": "modal",
                                                        "aria-hidden": "true"
                                                      }
                                                    },
                                                    [_vm._v("×")]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "modal-body" },
                                                [
                                                  _vm._l(
                                                    item.data
                                                      .variationProperties,
                                                    function(property) {
                                                      return property.property
                                                        .id == 58
                                                        ? _vm._l(
                                                            _vm.crossSellingData,
                                                            function(cross) {
                                                              return property.values.value
                                                                .split(",")
                                                                .map(Number)
                                                                .includes(
                                                                  cross.id
                                                                )
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "item"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "a",
                                                                        {
                                                                          attrs: {
                                                                            href: _vm._f(
                                                                              "itemURL"
                                                                            )(
                                                                              cross.data
                                                                            )
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "img"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "inner"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "img",
                                                                                    {
                                                                                      staticClass:
                                                                                        "lazyload",
                                                                                      attrs: {
                                                                                        "data-src":
                                                                                          cross
                                                                                            .data
                                                                                            .images
                                                                                            .all[0]
                                                                                            .urlMiddle,
                                                                                        src:
                                                                                          "",
                                                                                        alt:
                                                                                          ""
                                                                                      }
                                                                                    }
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  cross
                                                                                    .data
                                                                                    .prices
                                                                                    .rrp &&
                                                                                  cross
                                                                                    .data
                                                                                    .prices
                                                                                    .rrp
                                                                                    .unitPrice
                                                                                    .value >
                                                                                    0 &&
                                                                                  cross
                                                                                    .data
                                                                                    .prices
                                                                                    .rrp
                                                                                    .unitPrice
                                                                                    .value >
                                                                                    cross
                                                                                      .data
                                                                                      .prices
                                                                                      .default
                                                                                      .unitPrice
                                                                                      .value &&
                                                                                  100 -
                                                                                    (cross
                                                                                      .data
                                                                                      .prices
                                                                                      .default
                                                                                      .unitPrice
                                                                                      .value *
                                                                                      100) /
                                                                                      cross
                                                                                        .data
                                                                                        .prices
                                                                                        .rrp
                                                                                        .unitPrice
                                                                                        .value >=
                                                                                    10
                                                                                    ? _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "bubble percent-sale"
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "\n                                                                        -" +
                                                                                              _vm._s(
                                                                                                100 -
                                                                                                  (
                                                                                                    (cross
                                                                                                      .data
                                                                                                      .prices
                                                                                                      .default
                                                                                                      .unitPrice
                                                                                                      .value *
                                                                                                      100) /
                                                                                                    cross
                                                                                                      .data
                                                                                                      .prices
                                                                                                      .rrp
                                                                                                      .unitPrice
                                                                                                      .value
                                                                                                  ).toFixed(
                                                                                                    0
                                                                                                  )
                                                                                              ) +
                                                                                              "%\n                                                                    "
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e()
                                                                                ]
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "t"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  cross
                                                                                    .data
                                                                                    .texts
                                                                                    .name1
                                                                                )
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "price-container"
                                                                            },
                                                                            [
                                                                              cross
                                                                                .data
                                                                                .prices
                                                                                .rrp &&
                                                                              cross
                                                                                .data
                                                                                .prices
                                                                                .rrp
                                                                                .unitPrice
                                                                                .value >
                                                                                0 &&
                                                                              cross
                                                                                .data
                                                                                .prices
                                                                                .rrp
                                                                                .unitPrice
                                                                                .value >
                                                                                cross
                                                                                  .data
                                                                                  .prices
                                                                                  .default
                                                                                  .unitPrice
                                                                                  .value
                                                                                ? _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "rrp"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "\n                                                                    UVP: "
                                                                                      ),
                                                                                      _c(
                                                                                        "del",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              cross
                                                                                                .data
                                                                                                .prices
                                                                                                .rrp
                                                                                                .unitPrice
                                                                                                .formatted
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "Sie sparen: " +
                                                                                              _vm._s(
                                                                                                (
                                                                                                  cross
                                                                                                    .data
                                                                                                    .prices
                                                                                                    .rrp
                                                                                                    .unitPrice
                                                                                                    .value -
                                                                                                  cross
                                                                                                    .data
                                                                                                    .prices
                                                                                                    .default
                                                                                                    .unitPrice
                                                                                                    .value
                                                                                                )
                                                                                                  .toFixed(
                                                                                                    2
                                                                                                  )
                                                                                                  .replace(
                                                                                                    ".",
                                                                                                    ","
                                                                                                  )
                                                                                              ) +
                                                                                              " €"
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "p"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      cross
                                                                                        .data
                                                                                        .prices
                                                                                        .default
                                                                                        .unitPrice
                                                                                        .formatted
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "c2a"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Jetzt kaufen"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            }
                                                          )
                                                        : _vm._e()
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _vm._l(item.data.variationProperties, function(property) {
                        return property.property.id == 57 &&
                          property.values.value.startsWith("http")
                          ? [
                              _c(
                                "a",
                                {
                                  staticClass: "amz a",
                                  attrs: {
                                    href: property.values.value,
                                    target: "_blank"
                                  }
                                },
                                [_vm._v("Bei Amazon kaufen")]
                              )
                            ]
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ]
              )
            ],
            2
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img", staticStyle: { order: "-9999" } }, [
      _c("div", { staticClass: "inner" }, [
        _c("img", {
          attrs: {
            src:
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXIAAAFyAQMAAADS6sNKAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAACdJREFUeNrtwQENAAAAwiD7p7bHBwwAAAAAAAAAAAAAAAAAAAAAIOpFYAABNMkVpAAAAABJRU5ErkJggg==",
            alt: ""
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "btnsx", staticStyle: { order: "-9999" } },
      [_c("div", { staticClass: "inner" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "title", staticStyle: { order: "-9999" } },
      [_c("div", { staticClass: "inner" }, [_vm._v("Bezeichnung:")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "price", staticStyle: { order: "-9999" } },
      [_c("div", { staticClass: "inner" }, [_vm._v("Preis:")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "rating", staticStyle: { order: "-9999" } },
      [_c("div", { staticClass: "inner" }, [_vm._v("Bewertung:")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "add-disa", staticStyle: { order: "9999" } },
      [_c("div", { staticClass: "inner" }, [_vm._v("Vor- und Nachteile:")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "vote-container", staticStyle: { order: "9999" } },
      [
        _c("div", { staticClass: "vote" }, [
          _c("div", { staticClass: "inner" }, [
            _vm._v("Kundenvoting"),
            _c("span", { attrs: { id: "setTotalVotes" } }),
            _vm._v(":")
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btns", staticStyle: { order: "10001" } }, [
      _c("div", { staticClass: "inner" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "rate-inner" }, [
      _c("span", { staticClass: "rate-blank" }),
      _vm._v(" "),
      _c("span", { staticClass: "rate", staticStyle: { width: "0%" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "vote" }, [
      _c("div", { staticClass: "inner" }, [
        _c("span", { staticClass: "bar-c" }, [
          _c("span", { staticClass: "bar" })
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("0%")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }